import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getReasonNonExistenceOibTypes } from "../../slices/codeBookSlice";

export const useGetReasonNonExistenceOibTypes = () => {
  const reasonNonExistenceOibTypes = useSelector(
    (state: RootState) => state.codeBook.reasonNonExistenceOibTypes
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReasonNonExistenceOibTypes());
  }, [dispatch]);

  return reasonNonExistenceOibTypes;
};
